import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import splitString from "../helper/splitString";
import ChevronRightIcon from "../img/chevron_right_white.svg";
import CopyIcon from "../img/content_copy.svg";
import Snackbar from "@material-ui/core/Snackbar";

import UserIcon from "../img/user_account.svg";
import StarIcon from "../img/Stars_Magic_AI_LLM.svg";
import UserVariantIcon from "../img/user_account_variant.svg";
import CheckIcon from "../img/Check_Done_Circular_Fill.svg";
import classnames from "classnames";

import "../styles/infoBlock.scss";
import isEnglishString from "../helper/isEnglishString";

const colors = {
  "Existing Merchant Served": "bkash-pink",
  "Lead Followed-Up": "bkash-amber",
  "Lead Closed": "bkash-green",
  "Lead Generated": "bkash-blue",
};

const callOutComeIcons = {
  "Existing Merchant Served": StarIcon,
  "Lead Followed-Up": UserVariantIcon,
  "Lead Closed": CheckIcon,
  "Lead Generated": UserIcon,
};

const formatMobileNumber = (number) => {
  var n = number.replace("+88", "");
  var w = n.slice(0, 5) + " " + n.slice(5, 8) + " " + n.slice(8);
  return w;
};

const InfoBlock = ({
  icon,
  title,
  info,
  subInfo,
  secondarySubInfo,
  isCallOutcome,
  topVariant,
  goToPath,
  isSplitWords,
  splitLength = 30,
  isTruncated,
  copyMsg,
}) => {
  return (
    <div className="new-call-card-info-block">
      {icon && (
        <img
          src={icon}
          className="new-call-card-info-icon"
          style={{ width: title === "BMCC" || title === "Spot" ? 16 : 20 }}
        />
      )}
      <div
        className={classnames("new-call-card-info-text-container", {
          truncate: isTruncated,
        })}
        // className={
        //   isTruncated
        //     ? "new-call-card-info-text-container truncate"
        //     : "new-call-card-info-text-container"
        // }
      >
        {title && <p className="title">{title}</p>}
        {
          <p
            className={
              isCallOutcome
                ? `info call-outcome ${colors[info]}`
                : topVariant
                ? "info top"
                : "info"
            }
          >
            {isCallOutcome && <img src={callOutComeIcons[info]} />}
            {info ? (
              topVariant ? (
                formatMobileNumber(info)
              ) : (
                info
              )
            ) : (
              <b style={{ color: "grey", fontWeight: 400, fontSize: 12 }}>
                Not available
              </b>
            )}
            {copyMsg && info && <CopyInfo message={copyMsg} info={info} />}
          </p>
        }
        {subInfo && (
          <Tooltip
            title={isSplitWords && subInfo.length > splitLength ? subInfo : ""}
            placement="top"
            arrow
          >
            <p
              className={classnames("subInfo", {
                truncate: isTruncated,
                "bangla-font": !isEnglishString(subInfo),
              })}
              //className={isTruncated ? "subInfo truncate" : "subInfo"}
              // style={{
              //   fontFamily: title === "BMCC" ? "Noto Sans Bengali" : "Inter",
              // }}
            >
              {subInfo}
            </p>
          </Tooltip>
        )}
        {title === "Field Force" && !secondarySubInfo && (
          <p className="subInfo secondary unavailable">
            Distributor unavilable
          </p>
        )}
        {secondarySubInfo && (
          <Tooltip
            title={
              isSplitWords && secondarySubInfo.length > splitLength
                ? secondarySubInfo
                : ""
            }
            placement="top"
            arrow
          >
            <p className="subInfo secondary">{secondarySubInfo}</p>
          </Tooltip>
        )}
      </div>
      {topVariant && (
        <Link className="go-to-action-button" to={goToPath} target="_blank">
          <img src={ChevronRightIcon} />
        </Link>
      )}
    </div>
  );
};

const CopyInfo = ({ message, info }) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    navigator.clipboard.writeText(info);
    setOpen(true);
  };

  const handleClose = (event) => {
    setOpen(false);
  };

  return (
    <div className="copy-clipboard">
      <img src={CopyIcon} onClick={handleClick} />
      <Snackbar
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        autoHideDuration={3000}
        open={open}
        onClose={handleClose}
        message={`${message} ${info} is copied to clipboard`}
        key={"top_center_snackbar"}
      />
    </div>
  );
};

export default InfoBlock;
